import axios from 'axios';

// Use a relative path for API URL in production
const API_URL = '/api';

// Create axios instance with timeout and retry configuration
const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 10000, // 10 second timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for logging
apiClient.interceptors.request.use(
  (config) => {
    console.log(`Making ${config.method.toUpperCase()} request to: ${config.url}`);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    console.log(`Received response from ${response.config.url} with status: ${response.status}`);
    return response;
  },
  (error) => {
    // Handle network errors
    if (error.code === 'ERR_NETWORK') {
      console.error('Network error - Is the server running at ' + API_URL + '?');
      console.error('Error details:', error);
    }
    
    // Handle timeout errors
    if (error.code === 'ECONNABORTED') {
      console.error('Request timeout - Server took too long to respond');
    }
    
    // Handle server errors
    if (error.response) {
      console.error(`Server responded with error ${error.response.status}: ${error.response.data.message || 'Unknown error'}`);
    }
    
    return Promise.reject(error);
  }
);

// Function to test server connection
const testConnection = async () => {
  try {
    const response = await apiClient.get('/test');
    console.log('Server connection test successful:', response.data);
    return true;
  } catch (error) {
    console.error('Server connection test failed:', error.message);
    return false;
  }
};

// Salesforce API service
const salesforceApi = {
  // Test server connection
  testConnection,
  
  // Get opportunity data by ID
  getOpportunityById: async (opportunityId) => {
    try {
      // First test the connection
      const isConnected = await testConnection();
      if (!isConnected) {
        throw new Error('Cannot connect to server. Please check if the server is running.');
      }
      
      console.log(`Fetching opportunity data for ID: ${opportunityId}`);
      const response = await apiClient.post('/salesforce/opportunity', { 
        oppId: opportunityId 
      });
      
      console.log('Opportunity data received successfully');
      return response.data;
    } catch (error) {
      console.error('Error fetching opportunity data:', error);
      throw error;
    }
  },

  // Submit opportunity to lender
  submitToLender: async (lenderName, opportunityData, selectedFiles = null) => {
    try {
      console.log(`Submitting to lender: ${lenderName}`);
      console.log('Selected files:', selectedFiles);
      
      const payload = {
        lender: lenderName,
        opportunityData
      };
      
      // Add selected files if any
      if (selectedFiles) {
        payload.selectedFiles = selectedFiles;
      }
      
      const response = await apiClient.post('/lenders/submit', payload);
      
      console.log('Submission successful');
      return response.data;
    } catch (error) {
      console.error(`Error submitting to ${lenderName}:`, error);
      throw error;
    }
  }
};

export default salesforceApi; 